<div class="container h-100">
  <div class="row h-100">
    <div class="col-12 h-100">
      <div [class.out]="loading" class="shrink-top-animated h-100">
        <div class="text-center my-5">
          <fa-icon
            [icon]="spinnerIcon"
            animation="spin-pulse"
            class=""
            size="3x"
          ></fa-icon>
          <div class="">Die Ansicht wird geladen ...</div>
        </div>
      </div>
      <div [class.out]="!loading" class="shrink-top-animated p-0 p-md-3 h-100">
        <san-info-qrtne
          *ngIf="
            (!userParams.versorgungsVertragID && !userParams.vertragsgruppe) ||
              !userParams.uuid;
            else valid
          "
        ></san-info-qrtne>
        <ng-template #valid>
          <!--              1. QR Code Scannen (oder Link öffnen)-->
          <!--              2. Daten angeben-->
          <!--              2.1 KVNR, Geb.Dat., Name usw, Email-->
          <!--              2.2 Optional Adresse TBD-->
          <!--              3. Zustimmung geben (Checkboxen aktivieren)-->
          <!--              4. Email mit Bestätigung und Links empfangen (für Widerruf oder Abruf der TNE PDF)-->
          <!--              4.1. Klick auf Link => Eingabe KVNR, Geb.Dat.-->
          <!--              4.2 persönliche TNE Seite zum TNE Download oder Widerruf öffnet sich-->
          <san-stepper
            #stepperComponent
            [hideBottomButtons]="true"
            [showSteps]="false"
            class="mh-100"
          >
            <san-step #stepWillkommen *ngIf="!login">
              <san-willkommen
                (anmeldenClicked)="anmeldenAngeklickt()"
              ></san-willkommen>
            </san-step>
            <san-step #stepArztdaten *ngIf="!login">
              <san-infotext-arztdaten-qrtne
                #infotextArztdatenQRTNEComponent
                (weiterClicked)="arztBestaetigtGeklickt()"
                [krankenkassen]="krankenkassen"
                [state]="arztDatenResponseMitInputForm"
                [uuid]="userParams.uuid"
                [versorgungsVertragID]="userParams.versorgungsVertragID"
                [vertragsgruppe]="userParams.vertragsgruppe"
              ></san-infotext-arztdaten-qrtne>
            </san-step>
            <san-step #stepBasisdatenZwei *ngIf="!login">
              <san-basis-daten-eingabe-zwei
                (invalid)="goToErrorArztNichtEingeschrieben($event)"
                (ready)="stepperComponent.next()"
                (vertragGeladen)="vertragGeladen()"
                (zurueck)="zurueck()"
                [baseDataForm]="$any(arztDatenResponseMitInputForm.input_form)"
                [krankenkassen]="krankenkassen"
                [state]="arztDatenResponseMitInputForm"
                [userParams]="userParams"
              >
              </san-basis-daten-eingabe-zwei>
            </san-step>
            <san-step #stepBasisdaten *ngIf="!login">
              <san-basis-daten-eingabe
                (ready)="stepperComponent.next()"
                (zurueck)="zurueck()"
                [baseDataForm]="$any(arztDatenResponseMitInputForm.input_form)"
                [krankenkassen]="krankenkassen"
                [state]="arztDatenResponseMitInputForm"
              ></san-basis-daten-eingabe>
            </san-step>
            <san-step #stepTnz *ngIf="!login">
              <san-tnzeingabe
                (ready)="setTnz() && stepperComponent.next()"
                (zurueck)="zurueck()"
                [state]="arztDatenResponseMitInputForm"
                [tnzBeginn]="$any(tnz_form.get('tnz_beginn'))"
              ></san-tnzeingabe>
            </san-step>
            <san-step #stepZustimmung *ngIf="!login">
              <san-zustimmung-digi-tne-zwei
                (bestaetigenClicked)="einschreiben($event)"
                (zurueck)="zurueck()"
                [sending]="sending"
                [state]="arztDatenResponseMitInputForm"
              ></san-zustimmung-digi-tne-zwei>
            </san-step>
            <san-step #stepZustimmungBestaetigung *ngIf="!login">
              <san-zustimmung-bestaetigung-digi-tne-zwei
                (abmeldenClicked)="abmelden()"
                (downloadTneClicked)="downloadTNE()"
                (widerrufClicked)="widerruf()"
                [geburtsdatum]="
                  arztDatenResponseMitInputForm.input_form.get('geburtsdatum')
                    .value
                "
                [state]="previewState"
                [teilnahmeerklaerung]="
                  previewState?.teilnahmeerklaerung_abrufbar
                "
                [versicherten_nummer]="
                  arztDatenResponseMitInputForm.input_form.get(
                    'versicherten_nummer'
                  ).value
                "
                [widerruf]="showLinkToWiderruf"
              ></san-zustimmung-bestaetigung-digi-tne-zwei>
            </san-step>
            <san-step #stepLogin>
              <san-login (anmeldenClicked)="checkLogin($event)"></san-login>
            </san-step>
            <san-step #stepZustimmungBestaetigungNachLogin>
              <san-zustimmung-bestaetigung-digi-tne-zwei
                (abmeldenClicked)="abmelden()"
                (downloadTneClicked)="downloadTNE()"
                (widerrufClicked)="widerruf()"
                [geburtsdatum]="
                  arztDatenResponseMitInputForm.input_form.get('geburtsdatum')
                    .value
                "
                [state]="previewState"
                [teilnahmeerklaerung]="
                  previewState?.teilnahmeerklaerung_abrufbar
                "
                [versicherten_nummer]="
                  arztDatenResponseMitInputForm.input_form.get(
                    'versicherten_nummer'
                  ).value
                "
                [widerruf]="showLinkToWiderruf"
              ></san-zustimmung-bestaetigung-digi-tne-zwei>
            </san-step>
            <san-step #stepWiderruf>
              <san-widerruf
                (abmeldenClicked)="abmelden()"
                (bestaetigenClicked)="widerrufBestaetigen()"
                (downloadTneClicked)="downloadTNE()"
                [credentials]="creds"
                [state]="state"
                [teilnahmeerklaerung]="state?.teilnahmeerklaerung_abrufbar"
              ></san-widerruf>
            </san-step>
            <san-step #stepWiderrufBestaetigung>
              <san-widerruf-bestaetigung
                (abmeldenClicked)="abmelden()"
                (downloadTneClicked)="downloadTNE()"
                [state]="state"
                [teilnahmeerklaerung]="state?.teilnahmeerklaerung_abrufbar"
              ></san-widerruf-bestaetigung>
            </san-step>
            <san-step #stepFehlerNichtEingeschrieben>
              <san-fehler-arzt-nicht-eingeschrieben
                (zurueck)="zurueckVonError()"
                [issue]="issue"
              ></san-fehler-arzt-nicht-eingeschrieben>
            </san-step>
          </san-stepper>
        </ng-template>
      </div>
    </div>
  </div>
</div>
